export default "__VITE_ASSET__DadJsrJq__"